/**
 * <pvz-size-chart>
 *
 * 商品詳細のサイズ情報モーダル。
 * サイズ選択の右にある [data-cpd-size-guide] を押すと開く。
 *
 * 見た目と開閉の作りは既存の <pvz-cart-added> (カート追加シート) に合わせている。
 * スマホは下からせり上がるシート、PC は中央のダイアログ (CSS 側で切り替え)。
 */
class PerverzeSizeChart extends HTMLElement {
  connectedCallback() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.closeButton = this.querySelector('.pvz-size-chart__close');
    this.trigger = null;

    // 同じページに複数のトリガーがあっても拾えるように document から引く
    document
      .querySelectorAll('[data-cpd-size-guide]')
      .forEach((el) => el.addEventListener('click', this.open));

    this.querySelectorAll('[data-pvz-size-chart-close]').forEach((el) =>
      el.addEventListener('click', this.close)
    );

    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  onKeydown(event) {
    if (event.key !== 'Escape' || this.hidden) return;
    event.stopPropagation();
    this.close();
  }

  open(event) {
    // 閉じたときにフォーカスを戻す先を覚えておく
    this.trigger = event && event.currentTarget ? event.currentTarget : null;

    this.hidden = false;
    // 次のフレームでクラスを付けてトランジションさせる
    requestAnimationFrame(() => this.classList.add('is-open'));
    document.body.classList.add('pvz-size-chart-open');
    if (this.closeButton) this.closeButton.focus();
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('pvz-size-chart-open');
    setTimeout(() => {
      this.hidden = true;
    }, 300);
    if (this.trigger) this.trigger.focus();
  }
}

if (!customElements.get('pvz-size-chart')) {
  customElements.define('pvz-size-chart', PerverzeSizeChart);
}

/**
 * サイズ表の横スクロール位置インジケーター。
 *
 * snippets/size-chart-table.liquid が出力する .cpd__size-chart すべてに効く。
 * モーダルでも詳細アコーディオンでも同じ挙動になる。
 *
 * 表示中の幅の割合ぶんの長さの黒い棒を、スクロール量に応じて動かす
 * (商品画像の .cpd__progress と同じ考え方)。
 * モーダルもアコーディオンも開くまでは幅が 0 なので、
 * 表示されたタイミングを ResizeObserver で拾って計算し直す。
 */
function setupSizeChartProgress(root) {
  const scroller = root.querySelector('.cpd__size-table-wrap');
  const track = root.querySelector('.cpd__size-progress');
  const bar = root.querySelector('.cpd__size-progress-bar');
  if (!scroller || !track || !bar) return;

  const update = () => {
    const max = scroller.scrollWidth - scroller.clientWidth;

    // 幅が確定していない (非表示) / スクロール不要なら棒線ごと隠す
    track.hidden = scroller.clientWidth === 0 || max <= 1;
    if (track.hidden) return;

    bar.style.width = `${(scroller.clientWidth / scroller.scrollWidth) * 100}%`;
    const travel = scroller.clientWidth - bar.offsetWidth;
    bar.style.transform = `translateX(${(scroller.scrollLeft / max) * travel}px)`;
  };

  let ticking = false;
  scroller.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  });

  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(update).observe(scroller);
  }
  window.addEventListener('resize', update);
  update();
}

document.querySelectorAll('.cpd__size-chart').forEach(setupSizeChartProgress);
